import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const FooterLinks = () => {
  const { t } = useTranslation('editor');

  const links = [
    { to: '/products', label: t('nav.products') },
    { to: '/solutions', label: t('nav.solutions') },
    { to: '/services', label: t('nav.services') },
    { to: '/pricing', label: t('nav.pricing') },
    { to: '/company', label: t('nav.company') },
    { to: '/contact', label: t('nav.contact') },
    { to: '/legal', label: t('nav.legal') },
  ];

  return (
    <div>
      <h3 className="text-sm font-semibold uppercase tracking-[0.18em] text-white mb-4">{t('nav.products')}</h3>
      <ul className="space-y-2">
        {links.map((link) => (
          <li key={link.to}>
            <Link
              to={link.to}
              className="text-slate-400 hover:text-cyan-200 transition-colors duration-200"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterLinks;
